import React from "react";

const DigitalCompanyCardContext = React.createContext();
export default DigitalCompanyCardContext;